import { useMemo } from "react";
import { Field, reduxForm } from "redux-form";
import { Modal, Select } from "components";
import { Button, Label } from "expano-components";

import useGet from "hooks/useGet";
import useCreate from "hooks/useCreate";

const SelectField = (props) => <Select {...props} />;

const AddShop = ({
  handleClose,
  handleSubmit,
  change,
  pristine,
  platform_id,
  shop_ids,
  refetch,
}) => {
  const { data: shops } = useGet({
    query: ["shops", shop_ids],
    context: "list",
    path: "/shops",
    search: {
      per_page: 1000,
      "q[id_not_in]": shop_ids,
    },
  });

  const { is_creating, create } = useCreate({
    path: "/channels",
    onSuccess: () => [refetch(), handleClose()],
  });

  const onSubmit = ({ shop_id }) =>
    create({
      shop_id,
      platform_id,
    });

  const shop_options = useMemo(() => {
    if (!shops?.length) {
      return [];
    }

    return shops.map(({ id, name, label_color, label_text }) => ({
      label: (
        <>
          <Label text={label_text} type="fill" color={label_color} />
          <span>{name}</span>
        </>
      ),
      value: id,
    }));
  }, [shops]);

  return (
    <Modal
      handleClose={handleClose}
      header={{
        title: "Dodaj sklep",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            text="Dodaj"
            disabled={pristine || is_creating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Field
          label="Sklep"
          name="shop_id"
          component={SelectField}
          options={shop_options}
          handleChange={(value) => change("shop_id", value)}
        />
      </form>
    </Modal>
  );
};

export default reduxForm({
  form: "create-channel-by-shop",
  initialValues: { shop_id: null },
})(AddShop);
